interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export function DownloadIcon({ size = 24, color, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      style={color ? { color } : undefined}
      className={className}
      aria-hidden="true"
    >
      <path d="M13.25 15C13.6656 15 14 14.6656 14 14.25C14 13.8344 13.6656 13.5 13.25 13.5H2.75C2.33437 13.5 2 13.8344 2 14.25C2 14.6656 2.33437 15 2.75 15H13.25ZM7.45312 10.7625C7.59375 10.9125 7.79375 11 8 11C8.20625 11 8.40312 10.9156 8.54688 10.7625L12.5469 6.5125C12.8313 6.20937 12.8156 5.7375 12.5156 5.45312C12.2156 5.16875 11.7406 5.18437 11.4563 5.48438L8.75 8.35938V5.75V1.75C8.75 1.33437 8.41563 1 8 1C7.58437 1 7.25 1.33437 7.25 1.75V5.75V8.35938L4.54688 5.4875C4.2625 5.18438 3.7875 5.17188 3.4875 5.45625C3.1875 5.74063 3.17188 6.21562 3.45625 6.51562L7.45625 10.7656L7.45312 10.7625Z" />
    </svg>
  );
}
